import React, { useContext, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';

import { ThemeContext } from './contexts/ThemeContext';
import ScrollToTop from './utils/ScrollToTop';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import './App.css';
import PageSkeleton from './components/PageSkeleton/PageSkeleton';

// صفحه اصلی eager — بدون Suspense spinner در اولین بارگذاری
import Main from './pages/Main/Main';

// بارگذاری تنبل صفحات دیگر
const BlogPage = React.lazy(() => import('./pages/Blog/BlogPage'));
const ProjectPage = React.lazy(() => import('./pages/Projects/ProjectPage'));
const ProjectDetails = React.lazy(() => import('./pages/ProjectDetails/ProjectDetails'));
const LandingPage = React.lazy(() => import('./pages/Landing/LandingPage'));
const SkillsPage = React.lazy(() => import('./pages/Skills/SkillsPage'));
const MarketingPage = React.lazy(() => import('./pages/Marketing/MarketingPage'));
const ServicePage = React.lazy(() => import('./pages/Service/ServicePage'));
const HoldingPage = React.lazy(() => import('./pages/Holding/HoldingPage'));
const MavadPage = React.lazy(() => import('./pages/Mavad/MavadPage'));
const ItemDetails = React.lazy(() => import('./pages/ItemDetails/ItemDetails'));
const LandingDetails = React.lazy(() => import('./pages/LandingDetails/LandingDetails'));
const CosmeticsPage = React.lazy(() => import('./pages/Cosmetics/CosmeticsPage'));
const BeautyPage = React.lazy(() => import('./pages/Beauty/BeautyPage'));
const BackToTop = React.lazy(() => import('./components/BackToTop/BackToTop'));
const ServiceDetails = React.lazy(() => import('./pages/ServiceDetails/ServiceDetails'));
const TrainPage = React.lazy(() => import('./pages/Train/TrainPage'));
const TrainingDetails = React.lazy(() => import('./pages/TrainingDetails/TrainingDetails'));
const DoctorDetails = React.lazy(() => import('./pages/DoctorDetails/DoctorDetails'));
const BrandDetails = React.lazy(() => import('./pages/BrandDetails/BrandDetails'));
const CenterDetails = React.lazy(() => import('./pages/CenterDetails/CenterDetails'));
const WeightLossDetails = React.lazy(() => import('./pages/WeightLossDetails/WeightLossDetails'));
const HairSkinDetails = React.lazy(() => import('./pages/HairSkinDetails/HairSkinDetails'));
const ContactPage = React.lazy(() => import('./pages/Contact/ContactPage'));
const EducationPage = React.lazy(() => import('./pages/Education/EducationPage'));
const SearchPage = React.lazy(() => import('./pages/Search/SearchPage'));
const ChatAdmin  = React.lazy(() => import('./pages/ChatAdmin/ChatAdmin'));
const NotFound   = React.lazy(() => import('./pages/NotFound/NotFound'));
const PrivacyPage = React.lazy(() => import('./pages/Privacy/PrivacyPage'));
const AdminDashboard = React.lazy(() => import('./pages/AdminDashboard/AdminDashboard'));
const PackagingDetails = React.lazy(() => import('./pages/PackagingDetails/PackagingDetails'));
const AboutPage = React.lazy(() => import('./pages/About/AboutPage'));


function App() {
  const { theme } = useContext(ThemeContext);

  if (process.env.NODE_ENV === 'production') {
    console.log = console.warn = console.error = () => {};
  }

  return (
    <div className="app">
      <Router>
        <ScrollToTop />
        <ErrorBoundary>
        <Suspense fallback={<PageSkeleton />}>
          <Routes>
            <Route path="/" element={<Main />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/projects" element={<ProjectPage />} />
            <Route path="/projects/:id" element={<ProjectDetails />} />
            <Route path="/landing/" element={<LandingPage />} />
            <Route path="/Skills" element={<SkillsPage />} />
            <Route path="/Marketing" element={<MarketingPage />} />
            <Route path="/Service" element={<ServicePage />} />
            <Route path="/Holding" element={<HoldingPage />} />
            <Route path="/mavad/:type" element={<MavadPage />} />
            <Route path="/item/:id" element={<ItemDetails />} />
            <Route path="/product/:id" element={<LandingDetails />} />
            <Route path="/cosmetics" element={<CosmeticsPage />} />
            <Route path="/beauty" element={<BeautyPage />} />
            <Route path="/service/:id" element={<ServiceDetails />} />
            <Route path="/train" element={<TrainPage />} />
            <Route path="/trainings/:id" element={<TrainingDetails />} />
            <Route path="/doctor-details/:id" element={<DoctorDetails />} />
           <Route path="/brand-details/:id" element={<BrandDetails />} />
           <Route path="/center-details/:id" element={<CenterDetails />} />
            <Route path="/weight-loss-details/:id" element={<WeightLossDetails />} />
            <Route path="/hair-skin-details/:id" element={<HairSkinDetails />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/education" element={<EducationPage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/chat-admin" element={<ChatAdmin />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/my-admin" element={<AdminDashboard />} />
            <Route path="/carton/:id" element={<PackagingDetails />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
        </ErrorBoundary>
        <Suspense fallback={null}>
          <BackToTop />
        </Suspense>
      </Router>
    </div>
  );
}

export default App;
